import { ACTION_TYPES } from './actionTypes'

export const creditPayAction = (payload) => ({
	type: ACTION_TYPES.CREDIT_PAY,
	payload,
})
